import { dateFormatter } from "../../../../../config/Global";
import {
  idColumn,
  actionColumn,
  statusColumn,
} from "../../../../../utils/commonColumns";
import { generateColumn, renderNA, setDateFilterDefs } from "../../../../../utils/commonFunctions";
import { dateFormats } from "../../utils/constats";

const useColumnDefs = [
  idColumn,
  {
    ...generateColumn("", "module"),
  },
  {
    ...generateColumn("", "action"),
  },
  {
    ...generateColumn("User Name", ""),
    cellRenderer: (props: any) => {
      return renderNA(props?.data?.created_by?.name ? `${props.data.created_by.name} ${props.data.created_by.last_name}`:null);
    },
    filterValueGetter: (props: any) => {
      return renderNA(props?.data?.created_by?.name ? `${props.data.created_by.name} ${props.data.created_by.last_name}`:null);
    },
    valueGetter: (props: any) => {
      return renderNA(props?.data?.created_by?.name ? `${props.data.created_by.name} ${props.data.created_by.last_name}`:null);
    },
  },
  {
    ...generateColumn("User Email", ""),
    cellRenderer: (props: any) => {
      return renderNA(props?.data?.created_by?.email);
    },
    filterValueGetter: (props: any) => {
      return renderNA(props?.data?.created_by?.email);
    },
    valueGetter: (props: any) => {
      return renderNA(props?.data?.created_by?.email);
    },
  },
  {
    ...generateColumn("Role", ""),
    cellRenderer: (props: any) => {
      return renderNA(props?.data?.created_by?.role?.name);
    },
    filterValueGetter: (props: any) => {
      return renderNA(props?.data?.created_by?.role?.name);
    },
    valueGetter: (props: any) => {
      return renderNA(props?.data?.created_by?.role?.name);
    },
  },

  {
    ...generateColumn("Industry", `activity_industries_names`),

    cellRenderer: (props: any) => {
      return renderNA(props.data?.[`activity_industries_names`]?.map((data: any) => { return data })?.toString());
    },
    filterValueGetter: (props: any) => {
      return renderNA(props.data?.[`activity_industries_names`]?.map((data: any) => { return data })?.toString());
    },
    tooltipValueGetter: (props: any) => {
      return renderNA(props.data?.[`activity_industries_names`]?.map((data: any) => { return data })?.toString());
    },
    valueGetter: (props: any) => {
      return props.data?.[`activity_industries_names`]?.map((data: any) => { return data })?.join("#");
    },
  },

  {
    ...{
      field: "data.created_at",
      headerName: "Date",
      cellRenderer: (props: any) => {
        return props.data.created_at
          ? dateFormatter(props.data.created_at, dateFormats.dateFormat)
          : "N/A";
      },
      filterValueGetter: (props: any) => {
        return props.data.created_at
          ? dateFormatter(props.data.created_at, dateFormats.dateFormat)
          : "N/A";
      },
      valueGetter: (props: any) => {
        return props.data.created_at
          ? dateFormatter(props.data.created_at, dateFormats.dateFormat)
          : "N/A";
      },
    },
    ...setDateFilterDefs()
  },
  {
    ...{
      field: "data.created_at",
      headerName: "Time",
      cellRenderer: (props: any) => {
        return props.data.created_at
          ? dateFormatter(props.data.created_at, dateFormats.timeFormat)
          : "N/A";
      },
      filterValueGetter: (props: any) => {
        return props.data.created_at
          ? dateFormatter(props.data.created_at, dateFormats.timeFormat)
          : "N/A";
      },
      valueGetter: (props: any) => {
        return props.data.created_at
          ? dateFormatter(props.data.created_at, dateFormats.timeFormat)
          : "N/A";
      },
    },
  },
  actionColumn,
];
export default useColumnDefs;
